import PT from 'prop-types';
import { Link } from 'react-router-dom';
import style from './Breadcrumbs.scss';
import cx from 'classnames';

export const Crumb = ({ url, anchor, disable, children }) => {
  if (!children) {
    return null;
  }

  return (
    <li>
      {url ? (
        anchor ? (
          <a
            href={url}
            className={
              (cx(style.crumb, style.link), { [style.disabled]: disable })
            }
          >
            {children}
          </a>
        ) : (
          <Link
            to={url}
            className={
              (cx(style.crumb, style.link), { [style.disabled]: disable })
            }
          >
            {children}
          </Link>
        )
      ) : (
        <span className={style.crumb}>{children}</span>
      )}
    </li>
  );
};

Crumb.propTypes = {
  anchor: PT.bool,
  url: PT.string,
  disable: PT.bool,
};

export const Breadcrumbs = ({ children }) => {
  return (
    <nav className={style.breadcrumbs}>
      <ul>{children}</ul>
    </nav>
  );
};
